export default __webpack_public_path__ + "static/media/platejniykalendar.2d8e78f7.svg";